module.exports = __webpack_public_path__ + "static/media/bgpartner.6ca3dd23.png";